import { render, staticRenderFns } from "./UploadImgModal.vue?vue&type=template&id=fabb75b4&scoped=true"
import script from "./UploadImgModal.vue?vue&type=script&lang=js"
export * from "./UploadImgModal.vue?vue&type=script&lang=js"
import style0 from "./UploadImgModal.vue?vue&type=style&index=0&id=fabb75b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabb75b4",
  null
  
)

export default component.exports